import * as React from "react";
import { EditorState } from 'draft-js';
import { convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export interface InlineTextDisplayProps {
    source: string;
}

export default class InlineTextDisplay extends React.PureComponent<InlineTextDisplayProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
        };
    }

    componentDidMount() {
        this.updateEditorState();
    }

    componentDidUpdate(prevProps) {
        if (this.props.source != prevProps.source) {
            this.updateEditorState();
        }
    }

    updateEditorState() {
        let editorState = EditorState.createEmpty();
        if (this.props.source != "") {
            try {
                editorState = EditorState.createWithContent(convertFromRaw(JSON.parse(this.props.source)));
            } catch (error) {
                    editorState = EditorState.createEmpty();
                console.error(error);
            }
        }
        editorState
        this.setState({
            editorState: editorState,
        });
    }

    render() {

        return (
            <Editor
                editorState={this.state.editorState}
                editorClassName="inline-text-display"
                readOnly={true}
                toolbarHidden={true}
            />
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Controls/InlineTextDisplay.tsx